import DocumentoProcessoDigital from '@/core/apiclient/processo-digital/DocumentoProcessoDigital'

const URL_PATH = 'api/atas'

export default new DocumentoProcessoDigital(URL_PATH)
